import { useEffect } from 'react';
import { useAppDispatch } from '../redux/hooks';
import { initializeLanguage } from '../redux/languageSlice';

interface I18nInitializerProps {
  children: React.ReactNode;
}

export const I18nInitializer: React.FC<I18nInitializerProps> = ({ children }) => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    // Initialize language from i18n
    dispatch(initializeLanguage());
  }, [dispatch]);

  return <>{children}</>;
};